import { render, staticRenderFns } from "./UserPersonalConfirmationPage.vue?vue&type=template&id=0822448a&scoped=true"
import script from "./UserPersonalConfirmationPage.vue?vue&type=script&lang=js"
export * from "./UserPersonalConfirmationPage.vue?vue&type=script&lang=js"
import style0 from "./UserPersonalConfirmationPage.vue?vue&type=style&index=0&id=0822448a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0822448a",
  null
  
)

export default component.exports